import React, {useEffect, useRef, useState} from 'react'
import HeaderCard from "../../common/header-author/Header-Card";
import CardOngoing from "../../cards/CardOngoing";
import {get} from "sodon-http/API";
import {API_URL} from "../../../constans/API_URL";
import MovieModal from "../../modal/MovieModal";
import CustomPopup from "../../common/pop-up/CustomPopup";
import Slider from "react-slick";
import ChevronLeft from "../../icons/ChevronLeft";
import ChevronRight from "../../icons/ChevronRight";
import {useQuery} from "@tanstack/react-query";


export default function Ongoing() {


    const slickRef = useRef();
    const [popup, setPopup] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const [isDragging, setIsDragging] = useState(false);




    const { data: ongoingData } = useQuery({
        queryKey: ['ONGOING'],
        queryFn: async () => {
            return await get(`${API_URL}/api/movie/list?movieStatus=ONGOING`);
        },
    });

    const data = ongoingData?.payload.thisPageElements.slice(0, 16) ;



    function openDialog(item) {
        setSelectedItem(item);
        setPopup(true);
    }

    function handleClose(e) {
        setPopup(false);
    }


    const goNext = () => {
        if (slickRef.current)
            slickRef.current.slickNext()
    }
    const goPrev = () => {
        if (slickRef.current)
            slickRef.current.slickPrev()
    }


    let settings = {
        dots: false,
        infinite: true,
        fade: false,
        arrows: false,
        speed: 800,
        slidesToShow: 8,
        slidesToScroll: 4,
        autoplay: false,
        autoplaySpeed: 3500,
        className: "thisYear-slider-container",
        dotsClass: "thisYear-slider-pagination",
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 8,
                    slidesToScroll: 3,
                    infinite: true,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: true,
                }
            }
        ]
    };

    return (
        <>
            <div className={"container"}>
                <div className="ongoing mt-5 gap-2" >
                    <HeaderCard  title={"Орчуулж байгаа анимэнууд"} link={'anime-ongoing'} />
                    <div >
                        <Slider {...settings} ref={slickRef} >
                            {data && data.map((item, index) => (
                                <CardOngoing key={index} item={item} onClick={() => {openDialog(item)}} />
                            ))}
                        </Slider>
                    </div>
                    <div className="this-year-prev" onClick={goPrev}>
                        <ChevronLeft/>
                    </div>
                    <div className="this-year-next" onClick={goNext}>
                        <ChevronRight/>
                    </div>
                </div>
            </div>
            <CustomPopup open={popup} close={handleClose}>
                <MovieModal
                    item={selectedItem}
                    shown={popup}
                    setShown={value => setPopup(value)}
                />
            </CustomPopup>
        </>
    )
}
